export class OrgFilteredItem {
  constructor({ id, name, tags, createdAt, createdByName, model }){
    this.id = id;
    this.name = name;
    this.tags = tags;
    this.createdAt = createdAt;
    this.createdByName = createdByName;
    this.model = model;
  }
}